import {DeepPartial} from "../index";

export function merge<T>(base: T, diff: DeepPartial<T>|Partial<T>): T {
    const keys = [...new Set([...Object.keys(base), ...Object.keys(diff)])];
    const merged: T = {} as T;
    for (let key of keys) {
        if (base[key] === undefined) {
            merged[key] = diff[key];
        } else if (diff[key] !== undefined) {
            if (typeof diff[key] === "object" && !Array.isArray(diff[key])) {
                merged[key] = merge(base[key], diff[key]);
            } else {
                merged[key] = diff[key];
            }
        } else {
            merged[key] = base[key];
        }
    }
    return merged;
}
